export const RECEIVED = 'Received'
export const FAILED = 'Failed'
export const ENTERED = 'Entered'
export const CANCELLED = 'Cancelled'
export const STOCKRECEIVED = 'Stock received'
